export default "__VITE_ASSET__7dh2FvUd__"